import { useState } from "react";
import { toast } from "sonner";
import { formatApiError } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { cn } from "../../lib/utils";

export const SPACE_COLORS = ["#1B2A6B", "#E31E24", "#0E7490", "#7C3AED", "#B45309", "#047857"];

export default function EntityDialog({ open, onClose, title, onSubmit, showColor, initialName = "", initialColor = SPACE_COLORS[0], testid }) {
  const [name, setName] = useState(initialName);
  const [color, setColor] = useState(initialColor);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      await onSubmit(name.trim(), color);
      setName("");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-sm" data-testid={`${testid}-dialog`}>
        <DialogHeader><DialogTitle className="font-heading">{title}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input autoFocus data-testid={`${testid}-name-input`} value={name} onChange={(e) => setName(e.target.value)} placeholder="Name"
            className="w-full h-9 px-3 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
          {showColor && (
            <div className="flex gap-2" data-testid={`${testid}-color-picker`}>
              {SPACE_COLORS.map((c) => (
                <button type="button" key={c} data-testid={`${testid}-color-${c.replace("#", "")}`} onClick={() => setColor(c)}
                  className={cn("h-6 w-6 rounded-full transition-transform", color === c && "ring-2 ring-offset-2 ring-foreground scale-110")}
                  style={{ backgroundColor: c }} />
              ))}
            </div>
          )}
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" data-testid={`${testid}-cancel`} onClick={onClose} className="h-8 px-3 text-sm rounded-md border border-border hover:bg-muted transition-colors">Cancel</button>
            <button type="submit" data-testid={`${testid}-submit`} disabled={saving} className="h-8 px-3 text-sm rounded-md bg-[#E31E24] hover:bg-[#C81A1F] text-white font-medium transition-colors disabled:opacity-60">Save</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
